import "./services.css";
import { useEffect } from "react";
import { useRootContext } from "../../hooks/useRootContext";
import { useLocation, useNavigate } from "react-router-dom";

function Services() {
  const { setIsRouteLoading } = useRootContext();

  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      const el = document.getElementById(scrollToId);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className="services">
      <div className="services-header">
        <h1 className="services-header-heading animate__animated animate__fadeIn animate__slow" style={{ textTransform: "uppercase" }}>
          Attention to details , makes product’s quality
        </h1>
        <p className="services-header-desc animate__animated animate__fadeIn animate__slow">
          <span className="bold">With expertise, passion, </span> professionals with this skill
          meticulously review products, services, or processes to ensure they meet the required standards.
        </p>
      </div>

      <div className="services-list">
        <div className="service">
          <img
            className={`service-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/services-page-images/service-img-1.webp"
            alt="Service Img"
          />

          <div className="service-desc">
            <h2>Strategy</h2>
            <p>
              A strategy isn’t just a plan to hit our goals. For us, it’s a key part of what makes a product, shaped by thorough market research and a deep dive into what our customers really want.
            </p>
            <p>
              As we keep refining our strategy, we help guide important future choices and lay out bold visions to reach our best potential.
            </p>
            <img
              className={`service-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/services-page-images/service-img-1.webp"
              alt="Service Img"
            />
            <div className="service-desc-details">
              <h5>&#x2022; Analyze Customer Needs</h5>
              <h5>&#x2022; Checking Out the Market</h5>
              <h5>&#x2022; Defining the Product</h5>
              <h5>&#x2022; Vision for Our Digital Product</h5>
            </div>
          </div>
        </div>

        <div className="service" id="design">
          <div className="service-desc">
            <h2>Design</h2>
            <p>
              Design really plays a huge role in crafting awesome customer experiences. We kick things off by digging deep and gathering all the info we need.
            </p>
            <p>
              Our goal is to whip up designs that are super intuitive, efficient, and a breeze to use. That’s how we transform a design into a fantastic user experience!
            </p>
            <img
              className={`service-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/services-page-images/service-img-2.webp"
              alt="Service Img"
            />
            <div className="service-desc-details">
              <h5>&#x2022; Branding</h5>
              <h5>&#x2022; UI & UX Design</h5>
              <h5>&#x2022; Motion & Animation</h5>
              <h5>&#x2022; Quality Assurance</h5>
            </div>
          </div>

          <img
            className={`service-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/services-page-images/service-img-2.webp"
            alt="Service Img"
          />
        </div>

        <div className="service" id="development">
          <img
            className={`service-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/services-page-images/service-img-3.webp"
            alt="Service Img"
          />

          <div className="service-desc">
            <h2>Development</h2>
            <p>
              We use cutting-edge tech to give our clients awesome solutions. Our portfolio is packed with tons of options.
            </p>
            <p>
              We create native iOS and Android apps, handling both frontend and backend with clean, easy-to-maintain code.
            </p>
            <img
              className={`service-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/services-page-images/service-img-3.webp"
              alt="Service Img"
            />
            <div className="service-desc-details">
              <h5>&#x2022; Native Apps for iOS & Android</h5>
              <h5>&#x2022; Using React Native</h5>
              <h5>&#x2022; Backend (Ruby on Rails and Node.js)</h5>
              <h5>&#x2022; Testing for Quality Assurance</h5>
            </div>
          </div>
        </div>

        <div className="service">
          <div className="service-desc">
            <h2>Marketing</h2>
            <p>
              You could have the coolest design or the most groundbreaking product out there, but if nobody sees or uses it, it’s just not going to matter.
            </p>
            <p>
              To make sure your product gets the love and attention it deserves, we’re here to help you out in every way possible, especially with our awesome social media creatives!
            </p>
            <img
              className={`service-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/services-page-images/service-img-4.webp"
              alt="Service Img"
            />
            <div className="service-desc-details">
              <h5>&#x2022; Marketing Strategy</h5>
              <h5
                className="service-desc-details-link"
                onClick={() => {
                  navigate("/services/social-media-creatives#top");
                  setIsRouteLoading(true);
                }}
              >
                &#x2022; Meta Business Suite &rarr;
              </h5>
              <h5>&#x2022; Ads Performance</h5>
              <h5>&#x2022; Print Stuff (Design Materials)</h5>
            </div>
          </div>

          <img
            className={`service-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/services-page-images/service-img-4.webp"
            alt="Service Img"
          />
        </div>

        <div className="service">
          <img
            className={`service-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/services-page-images/service-img-5.webp"
            alt="Service Img"
          />

          <div className="service-desc">
            <h2>Optimization</h2>
            <p>
              Creating a product is just the beginning, but if you stop moving forward, you’re actually falling behind in this fast-paced digital world.
            </p>
            <p>
              The secret to improving what you’ve already made is to add new features and keep an eye on how users interact with it. That way, you can make smart choices for what comes next.
            </p>
            <img
              className={`service-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/services-page-images/service-img-5.webp"
              alt="Service Img"
            />
            <div className="service-desc-details">
              <h5>&#x2022; Analyse user behaviour</h5>
              <h5>&#x2022; Product Optimization</h5>
              <h5>&#x2022; Further Feature Development</h5>
              <h5>&#x2022; Advice on product decisions</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
